import React from "react";
import Chatbot from '../functions/Chatbot';

function Text() {
  return (
    <div class="main chat">
      <section id="chat" class="maintext">
        <Chatbot/>
      </section>
      <div className="floating-sidebar">
        <ul>
          <li><a href="/image"><button>Generate</button></a></li>
          <li><a href="/chat"><button>Visit</button></a></li>
          <li><a href="/scenario"><button>Play</button></a></li>
          <li><a href="/challenge"><button>Versus</button></a></li>
        </ul>
      </div>
    </div>
  );
}

export default Text;
